export default "https://cdn-static.gokick.com/assets/34e3985c60c1a4021cd40bb2eb2cab3e4962f61f/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";